module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticStyle: {
      "page-break-before": "always"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "P_Norm-Center__And__Page_Break",
    attrs: {
      "id": "auto_bookmark_toc_1"
    }
  }, [_c('span', [_vm._v("In memory of my father, Peter Jones. I’m glad we got to discuss this one.")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Norm-Center"
  }, [_c('span')]), _vm._v(" "), _c('p', {
    staticClass: "P_Norm-Center"
  }, [_c('span', [_vm._v("Dear Reader, if you get the feeling that someone is reading over your shoulder, but there’s no one there? Don’t panic—it’s just my dad. He’s checking my grammar. ;-)")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-34bd1666","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/section0003.vue
// module id = 63
// module chunks = 0